var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('pre-base',{attrs:{"pre_data":_vm.init_data}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{attrs:{"id":"notice"}},[_c('h5',[_vm._v("案例类别菜单使用说明:略。"),_c('br'),_c('span'),_c('br')])])])
}]

export { render, staticRenderFns }